import OlTable from './src/table';

/* istanbul ignore next */
OlTable.install = function(Vue) {
  Vue.component(OlTable.name, OlTable);
};

export default OlTable;
